<template>
	<div class="clean-label">
		<span class="clean-label__title"
			>{{ label }}&nbsp;&nbsp;<span
				class="toggler"
				ref="toggler"
				@mouseenter="tooltipShown = true"
				@mouseleave="tooltipShown = false"
				><i class="fal fa-info-circle" />
				<transition name="clean-label__tooltip">
					<div class="clean-label__tooltip" v-show="tooltipShown">
						{{ info }}

						<span
							class="clean-label__tooltip__arrow"
							:style="{ left: `${arrowOffset}px` }"
						></span>
					</div>
				</transition> </span
		></span>
		<span class="clean-label__pass"
			><span class="clean-label__check"
				><i class="fal fa-check-circle"></i
			></span>
			Pass</span
		>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tooltipShown: false,
			arrowOffset: 0
		};
	},
	props: {
		label: {
			type: String,
			required: true
		},
		info: {
			type: String,
			required: true
		}
	},
	mounted() {
		this.arrowOffset = this.$refs.toggler.offsetLeft + 10;
	}
};
</script>

<style lang="scss" scoped>
.clean-label {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	background-color: $white-off;
	border-radius: 2px;
	padding: 16px;
	& + & {
		margin-top: 2px;
	}

	&__pass {
		font-weight: 700;
	}

	&__check {
		color: $teal;
	}

	&__tooltip {
		position: absolute;
		top: 0;
		left: 0;
		width: 344px;
		padding: 32px;
		background-color: #ffffff;
		box-shadow: 0 10px 20px 0 rgba(51, 66, 66, 0.13);
		border-radius: 4px;
		transform: translateY(-110%);

		@include media("<=phone") {
			width: 100%;
		}

		&-enter-active,
		&-leave-active {
			transition: opacity 0.2s ease-in-out;
		}

		&-enter,
		&-leave-to {
			opacity: 0;
		}

		&__arrow {
			width: 50px;
			height: 25px;
			position: absolute;
			top: 100%;
			left: 50%;
			transform: translate(-50%, 0);
			overflow: hidden;

			@include media("<=phone") {
				left: 35%;
			}

			&::after {
				content: "";
				position: absolute;
				width: 20px;
				height: 20px;
				background: white;
				transform: translate(-50%, -50%) rotate(45deg);
				top: 0;
				left: 50%;
				box-shadow: 0 10px 20px 0 rgba(51, 66, 66, 0.13);
			}
		}
	}
}

.toggler {
	/* position: relative; */
}
</style>
